import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const useGofacOwnerResultQuery = ({
	id,
	ownerType,
	enabled = true,
}: {
	id: string;
	ownerType: string;
	enabled?: boolean;
}) =>
	useQuery(
		["gofacOwnerResult", id, ownerType],
		() => autoChecklistService.getGOFACowner(id, ownerType),
		{ retry: 0, cacheTime: 0, enabled: enabled && !!id && !!ownerType },
	);

export default useGofacOwnerResultQuery;
